import { useEffect } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { WalletResponseData } from '@/store/digital-gold/wallet-store';
import type { BaseResponse } from '@/types';
// https://be-testbed-v1.onemuthoot.com/api/v1/om
export const userWallet = (params: UserWalletType) => {
  // const token = cookiesStorage.getCookie('om-auth-user');

  // const headers = {
  //   Authorization: `Bearer ${token}`,
  //   // eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc01waW5TZXQiOiJ0cnVlIiwiaXNGaXJzdExvZ2luIjpmYWxzZSwidXNlcl9uYW1lIjoiNzAxMjI4MzM0OSIsInNjb3BlIjpbIlJFQUQiLCJXUklURSJdLCJleHAiOjE2ODM0NTE0MDMsImN1c3RvbWVyX2lkIjoiMGU2ODIzNWEtNmZhNS00OGMwLTk3OTAtNDRmYTBhMDEyZWQyIiwianRpIjoiZWI1ZDRmNmUtMjYzMS00ODc3LTlhOWQtZDY2M2U1YmZkODM3IiwiY2xpZW50X2lkIjoiY2xpZW50SWQifQ.lwD0ubZ7b8sd4-9rSx1gFbf0UScPH1LHkBQt7TH1h-Zs-xjZNEouPqDd0f1Xa-HZCEAjcXX--qJkTPK1jxD6hv193Iz_a9F_6HFjy23uAd4KYppljbGcwsf8h2r0iADBhOStXR_9AGqnTOwxCzpLkWc5zb4psV5dT6YCrl3XMsbkzVxPu9yQuUUmA5ln2YX2Xb0vc44daddU2Arco3-ksy5vjSjf0dotc-7VCsxZmMKVV0PFgsgZiWl0n8AFsT9mDSpZhIArXQtXAEByedUCW-c8LqMCay3fdh3mp8lqng7mV8sUgnKgN4wV0C-e0zLlBM3_6QTtf32-dys8M1J5XA'
  // };

  return axios<WalletResponseData, BaseResponse<WalletResponseData>, void>({
    url: `/dg/customers/${params.customerId}/gold-balance`,
    method: 'get',
    // headers
  });
};

export const useDgUserWallet = (params: UserWalletType) => {
  const { data, error, isSuccess } = useQuery({
    // isLoading,
    queryKey: ['dg-user-wallet', params],
    queryFn: () => userWallet(params),
    enabled: !!params.customerId,
    useErrorBoundary: false,
  });

  useEffect(() => {
    // const successMessage = data?.data?.meta?.omCustomMessage;
  }, [data]);

  const resultData = data?.data?.data as WalletResponseData;
  return {
    resultData,
    error,
    isSuccess,
  };
};
export type UserWalletType = {
  customerId: String | undefined;
};

// export type UserWalletResponseType = {
//   goldBalance: Number;
//   nonInvoicedBalance: Number;
//   dgTrendLineModel: {
//     amount: Number;
//     isProfitable: boolean;
//     percentage: Number;
//   };
// };
